import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { LandingPage } from './pages/LandingPage';
import { LanguageSelector } from './components/LanguageSelector';
export function App() {
  const [language, setLanguage] = useState<'en' | 'es' | null>(null);
  return <AnimatePresence mode="wait" data-id="element-0">
      {language === null ? <LanguageSelector key="language-selector" onSelect={(lang: string) => setLanguage(lang as 'en' | 'es')} data-id="element-1" /> : <LandingPage key="landing-page" lang={language} data-id="element-2" />}
    </AnimatePresence>;
}